/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-tab[_ngcontent-%COMP%] {\n  width: 100%;\n  overflow: hidden;\n  padding-top: 10px; }\n\n.hidden[_ngcontent-%COMP%] {\n  display: none; }\n\n.contentheader[_ngcontent-%COMP%], .contentheader2[_ngcontent-%COMP%] {\n  font-size: 1.25rem; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.scss.shim.ngstyle.js.pre-build-optimizer.js